import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-hide-button-cell',
  template: `
    <button mat-raised-button color="primary" style="line-height: 2" (click)="undo()">Undo</button>
  `
})
export class HistoryUndoButtonRendererComponent implements ICellRendererAngularComp {
    public params: any;

    constructor() {}

    agInit(params: any): void {
      this.params = params;
    }

    public undo() {
      this.params.context.componentParent.undoMatch(this.params.data);
    }

    refresh(): boolean {
      return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/history/history-undo-cell.component.ts